<template>
  <div v-if="selectedTextAnnotation" class="text-annotate-panel">
    <v-text-field
      v-model="localTranscript"
      :label="$t('annotate.text_transcript')"
      density="compact"
      variant="outlined"
      hide-details
      @change="emitTranscript"
    />
    <div class="text-caption text-grey mt-1" v-if="selectedTextAnnotation.transcript_source">
      {{ $t('annotate.text_source') }}: {{ selectedTextAnnotation.transcript_source }}
    </div>
  </div>
</template>

<script>
import { isTextLabelName } from '@/utils/textLabels';

export default {
  name: 'TextAnnotatePanel',
  props: {
    annotations: { required: true },
    selectedId: { default: null },
  },
  data() {
    return {
      localTranscript: '',
    };
  },
  computed: {
    selected() {
      if (!this.selectedId) return null;
      return this.annotations.find((a) => a.id === this.selectedId) || null;
    },
    selectedTextAnnotation() {
      if (!this.selected || !isTextLabelName(this.selected.label)) {
        return null;
      }
      return this.selected;
    },
  },
  watch: {
    selectedTextAnnotation: {
      immediate: true,
      handler(ann) {
        this.localTranscript = ann ? (ann.transcript || '') : '';
      },
    },
  },
  methods: {
    emitTranscript() {
      if (!this.selectedTextAnnotation) return;
      this.$emit('update-transcript', {
        id: this.selectedTextAnnotation.id,
        transcript: this.localTranscript,
        transcript_source: 'manual',
      });
    },
  },
};
</script>
